import { Dispatch, SetStateAction, useMemo, useState } from 'react';

export const useToggle = (
  defaultValue: boolean,
): [boolean, () => void, Dispatch<SetStateAction<boolean>>] => {
  const [value, setValue] = useState(defaultValue);
  const toggler = () => setValue((prev) => !prev);

  return [value, toggler, setValue];
};

export const useClassName = (
  ...classNames: Array<string | undefined | null | false>
): string =>
  useMemo<string>(
    () =>
      classNames.filter((it) => typeof it === 'string' && it !== '').join(' '),
    [classNames],
  );
